<div class="card full-card shadow-sm m-4 card-v-center">
  <div class="card-body">
    <div class="text col-md-12 text-center pt-2">
      <!--inserire img in alto a sx-->
      <h4 class="title" translate>upgrade-modal.form.title</h4>
      <h5 class="second-title pb-2" translate>
        upgrade-modal.form.secondary-title
      </h5>
    </div>
    <div class="text col-md-12 text-center mb-3"></div>

    <div class="container">
      <div class="row gx-0">
        <div
          class="offset-6 col-2 justify-content-between main-plan text-center"
          translate
          >
          upgrade-modal.smart-plan
        </div>
        <div
          class="col-2 justify-content-between main-plan text-center"
          translate
          >
          upgrade-modal.plus-plan
        </div>
        <div
          class="col-2 justify-content-between main-plan text-center"
          translate
          >
          upgrade-modal.premium-plan
        </div>
      </div>
    </div>
    <hr />
    <div class="container">
      <!-- Zeroest Line -->
      <div class="row gx-0 align-items-center py-2">
        <div class="col-6">
          <div [innerHTML]="'upgrade-modal.form.table.zero' | translate"></div>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
      </div>
      <!-- First Line -->
      <div class="row gx-0 align-items-center py-2">
        <div class="col-6">
          <div [innerHTML]="'upgrade-modal.form.table.first' | translate"></div>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
      </div>

      <!-- Second line -->
      <div class="row gx-0 align-items-center py-2">
        <div class="col-6">
          <div
            [innerHTML]="'upgrade-modal.form.table.first-second' | translate"
          ></div>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
      </div>

      <!-- Third line -->
      <div class="row gx-0 align-items-center py-2">
        <div class="col-6">
          <div
            [innerHTML]="'upgrade-modal.form.table.first-third' | translate"
          ></div>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
      </div>

      <div class="row gx-0 align-items-center py-2">
        <div class="col-6">
          <div
            [innerHTML]="'upgrade-modal.form.table.second' | translate"
          ></div>
        </div>
        <div class="offset-2 col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
      </div>
      <div class="row gx-0 align-items-center py-2">
        <div class="col-6">
          <div [innerHTML]="'upgrade-modal.form.table.third' | translate"></div>
        </div>
        <div class="offset-2 col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
      </div>
      <!-- Fourth line -->
      <div class="row gx-0 align-items-center py-2">
        <div class="col-6">
          <div
            [innerHTML]="'upgrade-modal.form.table.fourth' | translate"
          ></div>
        </div>
        <div class="offset-2 col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
      </div>
      <div class="row gx-0 align-items-center py-2">
        <div class="col-6">
          <div
            [innerHTML]="'upgrade-modal.form.table.fourth-second' | translate"
          ></div>
        </div>
        <div class="offset-2 col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
        <div class="col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
      </div>
      <!-- Fifth line -->
      <div class="row gx-0 align-items-center py-2">
        <div class="col-6">
          <div [innerHTML]="'upgrade-modal.form.table.fifth' | translate"></div>
        </div>
        <div class="offset-4 col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
      </div>

      <div class="row gx-0 align-items-center py-2">
        <div class="col-6">
          <div [innerHTML]="'upgrade-modal.form.table.sixth' | translate"></div>
        </div>
        <div class="offset-4 col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
      </div>
      <div class="row gx-0 align-items-center py-2">
        <div class="col-6">
          <div
            [innerHTML]="'upgrade-modal.form.table.seventh' | translate"
          ></div>
        </div>
        <div class="offset-4 col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
      </div>
      <div class="row gx-0 align-items-center py-2">
        <div class="col-6">
          <div
            [innerHTML]="'upgrade-modal.form.table.eighth' | translate"
          ></div>
        </div>
        <div class="offset-4 col-2 justify-content-between">
          <p class="text-center">
            <pwc-icon
              class="fill-orange"
              name="check"
              style="width: 15px"
            ></pwc-icon>
          </p>
        </div>
      </div>
    </div>
    <hr />

    <div class="container">
      <div class="row gx-0">
        <div class="select-plan col-12">
          <p class="select-plan" translate>upgrade-modal.form.select-plan</p>
        </div>
      </div>
      <form>
        <div class="row gx-0 justify-content-around no-gutters">
          @if (!isPlusEnabled) {
            <div
              class="col-12 col-md-6 col-4 p-1 pointer"
              (click)="selectUpgradePlan('plus')"
              >
              <div class="box-plan row gx-0 align-items-center justify-content-around">
                <div class="col align-items-center text-center">
                  <input
                    #radioPlus
                    id="plusRadio"
                    name="plusRadio"
                    type="radio"
                    [(ngModel)]="selectedPlan"
                    value="plus"
                    class="pointer"
                    />
                  <label
                    for="plusRadio"
                    class="title pointer"
                    style="margin-bottom: 0px"
                    translate
                    >
                    upgrade-modal.plus-plan
                  </label>
                </div>
                <div class="col">
                  <div class="col-12 cost-monthly" translate>
                    upgrade-modal.plus-plan-cost-yearly
                  </div>
                </div>
              </div>
            </div>
          }

          <div class="col-12 col-md-6 col-4 p-1">
            <div
              class="box-plan row gx-0 justify-content-around align-items-center pointer"
              (click)="selectUpgradePlan('premium')"
              >
              <div class="col align-items-center text-center">
                <input
                  #radioPremium
                  id="premiumRadio"
                  name="premiumRadio"
                  type="radio"
                  [(ngModel)]="selectedPlan"
                  value="premium"
                  class="pointer"
                  />
                <label
                  for="premiumRadio"
                  class="title pointer"
                  style="margin-bottom: 0px"
                  translate
                  >
                  upgrade-modal.premium-plan
                </label>
              </div>
              <div class="col row gx-0 align-items-center">
                <div class="col-12 cost-monthly" translate>
                  upgrade-modal.premium-plan-cost-yearly
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <hr />

    <div class="d-flex justify-content-between align-items-center">
      <button
        class="not btn btn-primary btn-rounded"
        (click)="goBack()"
        translate
        >
        upgrade-modal.form.cancel
      </button>

      <button
        [disabled]="!selectedPlan"
        class="btn btn-primary btn-rounded"
        (click)="onPlanChoose()"
        translate
        >
        upgrade-modal.form.request-upgrade
      </button>
    </div>
  </div>
</div>
